export const contact = {
  phone: "+91 97840 95593",
  phoneHref: "+919784095593",
  whatsapp: "919784095593",
  email: "madm6101994@gmail.com",
  instagram: "madminute.official",
};

export const services = [
  {
    number: "01",
    title: "Automotive R&D",
    copy: "Consultancy, validation, hybrid and electric vehicle testing, and race-ready technology integration.",
    link: "/rnd",
  },
  {
    number: "02",
    title: "Production & Media",
    copy: "High-energy films, photo-videography, event coverage, and stories built around movement.",
    link: "/production",
  },
  {
    number: "03",
    title: "Motorsports Management",
    copy: "From planning to the finish line—event management, field execution, and motorsport experiences.",
    link: "/#services",
  },
  {
    number: "04",
    title: "Gear & Apparel",
    copy: "Adventure-led jackets, tees, cargos, and motorsports gear for people who live beyond the track.",
    link: "/store",
  },
];

export const whatsappUrl = (message) =>
  `https://wa.me/${contact.whatsapp}?text=${encodeURIComponent(message)}`;
